<template>
    <div>
        <vueper-slides lazy lazy-load-on-drag :autoplay="autoplay" :dragging-distance="50" :fixed-height="true" class="hidden-on-mobile desktop-sized-carousel">
            <vueper-slide
                v-for="slide in slides"
                :key="slide.id"
                :content="slide.content"
                :image="slide.image"
                :video="slide.video"
                :link="slide.url"/>
        </vueper-slides>

        <vueper-slides lazy lazy-load-on-drag :autoplay="autoplay" :dragging-distance="50" :slide-ratio="1.5" :arrows="false" class="hidden-on-desktop mobile-sized-carousel">
            <vueper-slide
                v-for="slide in slides"
                :key="slide.id"
                :content="slide.content"
                :image="slide.smallImage"
                :video="slide.smallVideo"
                :link="slide.url"/>
        </vueper-slides>
    </div>
</template>

<script>
import {VueperSlide, VueperSlides} from 'vueperslides'

export default {
    name: 'CarouselComponent',
    components: {VueperSlides, VueperSlide},

    props: {
        slides: {
            type: Array,
        }
    },

    data() {
        return {
            autoplay: this.slides.length > 1
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .carousel-component-content-video {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    object-fit: cover;
}
</style>
